import { apiClient } from '@/api/request'
import type { TraceInstanceOption } from '@/components/traceSearch'

type JsonObject = Record<string, unknown>

/** 实例下拉的最大选项数 */
const MAX_INSTANCE_OPTIONS = 200

/** 列出模板下的实例，用于实例下拉 */
export async function listAgentInstanceOptions(agentId: string): Promise<TraceInstanceOption[]> {
  const envelope = (
    await apiClient.post<JsonObject>('/v2/ListInstances', {
      page: 1,
      page_size: MAX_INSTANCE_OPTIONS,
      filter: { agent_id: agentId }
    })
  ).data
  const items = ((envelope.data as JsonObject | undefined)?.items ?? []) as JsonObject[]
  return items.map(item => ({
    id: typeof item.id === 'string' ? item.id : '',
    name: typeof item.name === 'string' ? item.name : ''
  }))
}
